import PropTypes from 'prop-types';

const ConfirmSendMessagePropType = {
  onSendMessage: PropTypes.func.isRequired,
};

export default ConfirmSendMessagePropType;
